import { ChevronLeft, ChevronRight, X } from "lucide-react";

interface ModalNavControlsProps {
	/** Omitted when the modal has nothing to step through — only the close button renders then. */
	onPrevious?: () => void;
	onNext?: () => void;
	/** False at the ends of the list: the button stays in place but is disabled. */
	hasPrevious?: boolean;
	hasNext?: boolean;
	onClose: () => void;
}

/** Previous / Next / close row for the top-right corner of a detail modal.
 *  Shared by the inspection checklist item modal and the plan review finding modal so
 *  stepping through a list feels the same in both. */
const ModalNavControls = ({ onPrevious, onNext, hasPrevious, hasNext, onClose }: ModalNavControlsProps) => (
	<div className="mnc-controls">
		{onPrevious && onNext && (
			<>
				<button
					type="button"
					className="mnc-step-btn"
					onClick={onPrevious}
					disabled={!hasPrevious}
					aria-label="Previous item"
				>
					<ChevronLeft size={16} />
					Previous
				</button>
				<button type="button" className="mnc-step-btn" onClick={onNext} disabled={!hasNext} aria-label="Next item">
					Next
					<ChevronRight size={16} />
				</button>
				<span className="mnc-divider" />
			</>
		)}
		<button type="button" className="mnc-close-btn" onClick={onClose} aria-label="Close">
			<X size={16} />
		</button>
	</div>
);

export default ModalNavControls;
